import type { MeasurementStrategyContext, PdpMeasurementStrategy } from './PdpMeasurementStrategy';
import { bindSectionReachedObserver } from './sectionReachedObserver';

const REVIEW_SECTION_SELECTORS: readonly string[] = [
  '.product-detail-review',
  '#review-tab-pane',
  '.trustpilot-widget',
  '[data-trustpilot-widget]',
];

/**
 * Reviews block visibility: flips `reviews_reached` when native Shopware review UI or common UGC embed
 * containers enter the viewport, using the shared late-binding helper so async-injected markup still works.
 *
 * Plugin coverage: yes — Trustpilot (e.g. ecocode “Trustpilot Reviews” / TrustBox: `.trustpilot-widget`,
 * `[data-trustpilot-widget]`); MILLENWORLD “Show product reviews next to the product description” when
 * the block still matches `.product-detail-review` / `#review-tab-pane`. Other review widgets: extend
 * `REVIEW_SECTION_SELECTORS`.
 */
export class ReviewsReachedStrategy implements PdpMeasurementStrategy {
  private disposeSection: (() => void) | null = null;

  attach(ctx: MeasurementStrategyContext): void {
    this.disposeSection = bindSectionReachedObserver({
      document: ctx.document,
      selectors: REVIEW_SECTION_SELECTORS,
      threshold: 0.1,
      onReached: () => {
        ctx.store.setReviewsReached();
      },
    });
  }

  dispose(): void {
    this.disposeSection?.();
    this.disposeSection = null;
  }
}
